import { ChatModuleType } from 'app/copied/models/ChatModules';

import { getStorageItem } from './storage/useStorage';
import useModule from './useModule';

function useIndicationSelector() {
  const indicationSelectorModule = useModule(ChatModuleType.IndicationSelector);
  const getSelectedIndication = () => {
    const currentConditionId = window?.ostro?.conditionId || getStorageItem('rx_condition_id');
    return indicationSelectorModule?.items?.find((item) => item.hub_condition_uuid === currentConditionId);
  };

  return {
    indicationSelectorModule,
    getSelectedIndication,
    primaryIndicationSelectorEnabled: indicationSelectorModule?.primary_selector_enabled,
    secondaryIndicationSelectorEnabled: indicationSelectorModule?.secondary_selector_enabled,
  };
}

export default useIndicationSelector;
